import { 
    // 批量指派房源列表
    apiBizGetBatchDispatchList,
    // 單一指派房源
    apiBizSingelUpdateDispatch,
    // 批量替換業務
    apiBizUpdateDispatchSales,
    // 批量替換房東
    apiBizUpdateDispatchLandlord,
    // 取得群組列表
    apiBizGetOrganizationGroupList,
    // 取得該群組業務列表
    apiBizGetMemberByGroup,
    } from "@/apis/api.js"; 

/* 
  這邊可以改為用 types 物件取代 matutions_type.js (繼續用也可以)
  然後在前面加上模組名稱作為前綴，用來避免與其他模組重複。
  因為 action、mutation、和 getter 依然是註冊在全域的命名空間
*/
const types = {
    set_checkbox_status: 'batchDispatch/set_checkbox_status',
    set_batch_dispatch_list: 'batchDispatch/set_batch_dispatch_list',
    set_selected_house: 'batchDispatch/set_selected_house',
    set_instead_loadlord_id: 'batchDispatch/set_instead_loadlord_id',
    set_instead_group_id: 'batchDispatch/set_instead_group_id',
    set_instead_sales_id: 'batchDispatch/set_instead_sales_id',
    set_filter_query: 'batchDispatch/set_filter_query',
    set_success_list: 'batchDispatch/set_success_list',
    set_org_group_list: 'batchDispatch/set_org_group_list',
    set_member_by_group: 'batchDispatch/set_member_by_group',
}

// count state 必須是 Object
const state = {
    bizBatchDispatchList: [],
    checkboxStatus: {
        checkboxAll: false,
    },
    selectedHouse: [],
    insteadLandlordId: null,
    insteadGroupAndSales: {
        groupId: null,
        agentId: null
    },
    filterQuery: {},
    filterQueryUpdate: 0,
    successList: [],
    organizationGroupList: [],
    memberByGroupList: [],
}

// getters 也可以整理到這邊直接返回 count 內容
const getters = {
    GET_BIZ_BATCH_DISPATCH_LIST: (state) => {
        return state.bizBatchDispatchList
    },
    GET_BIZ_BATCH_DISPATCH_SUCCESS_LIST: (state) => {
        return state.successList
    },
    GET_BIZ_BATCH_DISPATCH_LIST_TOTAL: (state) => {
        return state.bizBatchDispatchList.length
    },
    GET_BIZ_BATCH_DISPATCH_CHECKBOX_STATUS: (state) => {
        return state.checkboxStatus
    },
    GET_BIZ_BATCH_DISPATCH_HAS_SELECTED_HOUSE: (state) => {
        return state.selectedHouse.length?true:false
    },
    GET_BIZ_BATCH_DISPATCH_SELECTED_HOUSE_CID: (state) => {
        return state.selectedHouse
    },
    GET_BIZ_BATCH_DISPATCH_INSTEAD_LANDLORD_ID: (state) => {
        return state.insteadLandlordId
    },
    GET_BIZ_BATCH_DISPATCH_INSTEAD_GROUP_ID: (state) => {
        return state.insteadGroupAndSales.groupId
    },
    GET_BIZ_BATCH_DISPATCH_INSTEAD_SALES_ID: (state) => {
        return state.insteadGroupAndSales.agentId
    },
    GET_BIZ_BATCH_DISPATCH_FILTER_QUERY: (state) => {
        return state.filterQuery
    },
    GET_BIZ_BATCH_DISPATCH_FILTER_QUERY_UPDATE: (state) => {
        return state.filterQueryUpdate
    },
    GET_BIZ_DISPATCH_ORG_GROUP_LIST: (state) => {
        return state.organizationGroupList
    },
    GET_BIZ_DISPATCH_ORG_MEMBER_BY_GROUP_LIST: (state) => {
        return state.memberByGroupList
    },
}

// actions 也是以 Object 形式建構。
const actions = {
    getBizBatchDispatchList ( {commit}, data ) {
        return new Promise((resolve, reject) => {
            apiBizGetBatchDispatchList(data)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    let batchDispatch = res.data.result
                    commit(types.set_batch_dispatch_list, batchDispatch)
                    commit(types.set_success_list)
                    resolve()
                }
            })
            .catch(err => {
                reject(err)
            })
        })
    },
    updateBizSingleDispatch ( {commit, dispatch, getters}, data) {
        return new Promise((resolve, reject) => {
            
            apiBizSingelUpdateDispatch(data)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    dispatch('getBizBatchDispatchList')
                    commit(types.set_success_list)
                    resolve()
                }
            })
            .catch(err => {
                reject(err)
            })
        })
    },
    updateBizBatchDispatchLandlord ( {commit, dispatch, getters} ) {
        return new Promise((resolve, reject) => {
            let data = {
                houseIdList: getters.GET_BIZ_BATCH_DISPATCH_SELECTED_HOUSE_CID,
                landlordId: getters.GET_BIZ_BATCH_DISPATCH_INSTEAD_LANDLORD_ID,
            }
            apiBizUpdateDispatchLandlord(data)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    dispatch('getBizBatchDispatchList')
                    commit(types.set_success_list)
                    resolve()
                }
            })
            .catch(err => {
                reject(err)
            })
        })
    },
    updateBizBatchDispatchSales ( {commit, dispatch, getters} ) {
        return new Promise((resolve, reject) => {
            let data = {
                houseIdList: getters.GET_BIZ_BATCH_DISPATCH_SELECTED_HOUSE_CID,
                groupId: getters.GET_BIZ_BATCH_DISPATCH_INSTEAD_GROUP_ID,
                agentId: getters.GET_BIZ_BATCH_DISPATCH_INSTEAD_SALES_ID,
            }
            apiBizUpdateDispatchSales(data)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    dispatch('getBizBatchDispatchList')
                    commit(types.set_success_list)
                    resolve()
                }
            })
            .catch(err => {
                reject(err)
            })
        })
    },
    setBizBatchDispatchInsteadLandlordId ( {commit}, data ) {
        commit(types.set_instead_loadlord_id, data)
    },
    setBizBatchDispatchInsteadGroupId ( {commit}, data ) {
        commit(types.set_instead_group_id, data)
    },
    setBizBatchDispatchInsteadSalesId ( {commit}, data ) {
        commit(types.set_instead_sales_id, data)
    },
    setBizBatchDispatchCheckboxStatus ( {commit}, data ) {
        commit(types.set_checkbox_status, data)
    },
    setBizBatchDispatchSeletedHouse ( {commit}, data ) {
        commit(types.set_selected_house, data)
    },
    setBizBatchDispatchFilterQuery ( {commit} , value ) {
        return new Promise((resolve, reject) => {
            commit(types.set_filter_query, value);
            resolve()
        })
    },
    getBizDispatchOrgGroupList ( {commit}, data ) {
        return new Promise((resolve, reject) => {
            apiBizGetOrganizationGroupList()
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    commit(types.set_org_group_list, res.data.result)
                    resolve()
                }
            })
            .catch(err => {
            })
        })
    },
    getBizDispatchMemberByGroupList ( {commit}, data ) {
        return new Promise((resolve, reject) => {
            apiBizGetMemberByGroup(data)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    commit(types.set_member_by_group, res.data.result)
                    resolve()
                }
            })
            .catch(err => {
            })
        })
    },
}

// mutations
const mutations = {
    [types.set_checkbox_status](state, data){
        state.checkboxStatus = data
    },
    [types.set_selected_house](state, data){
        state.selectedHouse = data
    },
    [types.set_instead_loadlord_id](state, data){
        state.insteadLandlordId = data
    },
    [types.set_instead_group_id](state, data){
        state.insteadGroupAndSales.groupId = data
    },
    [types.set_instead_sales_id](state, data){
        state.insteadGroupAndSales.agentId = data
    },
    [types.set_batch_dispatch_list](state, data){
        state.bizBatchDispatchList = data
    },
    [types.set_filter_query](state, data){
        state.filterQuery = data
        state.filterQueryUpdate += 1
    },
    [types.set_success_list](state, data){
        if(data){
            state.successList = data
        }else{
            state.successList = state.selectedHouse
        }
    },
    [types.set_org_group_list](state, data){
        state.organizationGroupList = data
    },
    [types.set_member_by_group](state, data){
        state.memberByGroupList = data
    },
}

/*
因為我們把 vuex 所有職權都寫在同一隻檔案，
所以必須要 export 出去給最外層 index.js 組合使用
*/
export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/bussiness/mgtCategory/houseMgt/batchDispatch.js